<template>
  <div class="main ex">
    <div class="header">
      <a class="backBtn" @click="$router.go(-1)">
        <i class="icon_back"></i> {{ $t('back') }}
      </a>
    </div>
    <div class="exBox" v-if="projectInfo">
      <div class="exTitle" v-if="projectInfo.showLocalName">{{ projectInfo.showLocalName }}</div>
      <div class="exCom" v-if="projectInfo.organizer">{{ projectInfo.organizer }}</div>
      <div class="exView" v-if="projectInfo.visualIdentityImage">
        <img :src="projectInfo.visualIdentityImage" alt="show's banner" />
      </div>
      <div class="exInfo" v-if="projectInfo.showDescription" v-html="projectInfo.showDescription"/>
      <a @click="goToExhibitionList" class="btn_w">{{ $t('exhibitionPage.startToTour') }}</a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      projectInfo: null,
    }
  },
  created() {
    this.projectInfo = JSON.parse(localStorage.getItem('projectInfo'))
  },
  methods: {
    ...mapActions([
      'trackerLog',
    ]),
    goToExhibitionList() {
      // log
      this.trackerLog({
        event: 'click_start_exhibition',
        message: {
          exhibitionId: localStorage.getItem('projectCode'),
          exhibition: this.projectInfo.showLocalName,
        },
      })
      this.$router.push({ name: 'ExhibitionList' })
    },
  },
}
</script>

<style>
</style>
